import { FC, ReactNode } from 'react'

type ProductUnitModalProperties = {
  title: string
  onClose: () => void
  primaryButtonLabel: string
  primaryButtonOnClick: () => void
  secondaryButtonLabel?: string
  secondaryButtonOnClick?: () => void
  children: ReactNode
}

export const ProductUnitModal: FC<ProductUnitModalProperties> = ({
  title,
  onClose,
  primaryButtonLabel,
  primaryButtonOnClick,
  secondaryButtonLabel,
  secondaryButtonOnClick,
  children,
}) => {
  const hasSecondaryButton = !!secondaryButtonLabel && !!secondaryButtonOnClick

  return (
    <div className="cmp-product-units__machine-modal" role="dialog" aria-modal="true">
      <div className="cmp-product-units__machine-modal__header">
        <button
          className="cmp-product-units__machine-modal__close"
          onClick={onClose}
          type="button"
          aria-label="Close modal"
        >
          ✕
        </button>
        <h3 className="cmp-product-units__machine-modal__title">{title}</h3>
      </div>

      {children}

      <div className="cmp-product-units__machine-modal__footer">
        {hasSecondaryButton && (
          <button
            onClick={secondaryButtonOnClick}
            type="button"
            className="cmp-product-units__machine-modal__footer-button"
          >
            {secondaryButtonLabel}
          </button>
        )}
        <button
          onClick={primaryButtonOnClick}
          type="button"
          className="cmp-product-units__machine-modal__footer-button"
        >
          {primaryButtonLabel}
        </button>
      </div>
    </div>
  )
}
